import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-13fa6b50")
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "main-visual-area" }
const _hoisted_3 = { class: "inner flex-box jc-sb" }
const _hoisted_4 = { class: "catch-phrase-area" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("勉強会を")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("もっと気軽に。")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("もっと便利に。")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "catch-phrase" }, "勉強会の進捗状況を楽に管理したい", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "catch-phrase" }, "勉強会の質問しづらい雰囲気を解消したい", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "catch-phrase" }, "こんな悩みはツールで解決しよう。", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("ルームを作成する")
const _hoisted_14 = { class: "main-visual" }
const _hoisted_15 = { class: "main-contents" }
const _hoisted_16 = { class: "inner" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("あなたの勉強会、こんな状態になっていませんか？")
const _hoisted_18 = { class: "head flex-box jc-sb" }
const _hoisted_19 = { class: "img-box" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "description-area" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 小規模なハンズオン形式の勉強会における進捗管理では、Slackなどのチャットツールを使うケースが多いです。 "),
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " 講師側は、受講者全体の進捗を見ながら解説を始めるかどうかの判断をしたい一方で、受講者側は周りの人が完了すると焦ってハンズオンに集中できなくなるという課題がありました。 "),
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " また、勉強会参加者のレベルは様々で、質問をしたくても初歩的すぎる質問は恥ずかしい、という思いから勉強会における質疑応答が活発化しないという課題もあります。 ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_heading = _resolveComponent("heading")!
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_retina_img = _resolveComponent("retina-img")!
  const _component_top_issue = _resolveComponent("top-issue")!
  const _component_top_solution = _resolveComponent("top-solution")!
  const _component_top_how_to_use = _resolveComponent("top-how-to-use")!
  const _component_top_create_room_window = _resolveComponent("top-create-room-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_heading, { level: 1 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }),
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createVNode(_component_custom_button, {
            type: "round",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalOpen = true))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_retina_img, {
            src: "/images/main-visual.png",
            alt: "メインビジュアル",
            width: 590,
            height: 302
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_heading, {
          level: 2,
          textAlign: "center"
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }),
        _createElementVNode("section", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_retina_img, {
              src: "/images/study-group01.png",
              alt: "勉強会で悩んでいるイラスト",
              width: 300,
              height: 263
            })
          ]),
          _hoisted_20
        ])
      ]),
      _createVNode(_component_top_issue),
      _createVNode(_component_top_solution),
      _createVNode(_component_top_how_to_use)
    ]),
    _createVNode(_component_top_create_room_window, {
      open: _ctx.isModalOpen,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isModalOpen = false))
    }, null, 8, ["open"])
  ]))
}